import { getDataFromCache } from "../../services/cachingService";
import { ChannelkartNetworkGet } from "../../services/networkService";

export const getDatesForPTD = async () => {
    let url = `/v1/query/getDateRange?BusinessCalendar={"date":{ "type":"LXP","X":"0"}}`;

    const queryResponse = await getDataFromCache(url, 15, async () => {
        const response = await ChannelkartNetworkGet(url);
        return response;
    });
    return queryResponse;
}

export const getDatesForLastWeek = async () => {
    let url = `/v1/query/getDateRange?BusinessCalendar={"date":{ "type":"LXW","X":"1"}}`;

    const queryResponse = await getDataFromCache(url, 15, async () => {
        const response = await ChannelkartNetworkGet(url);
        return response;
    });
    return queryResponse;
}

export const getDatesForLastMonth = async () => {
    let url = `/v1/query/getDateRange?BusinessCalendar={"date":{ "type":"LXP","X":"1"}}`;

    const queryResponse = await getDataFromCache(url, 15, async () => {
        const response = await ChannelkartNetworkGet(url);
        return response;
    });
    return queryResponse;
}

export const getData = async () => {
    const datesForPTD: Record<string, any> = await getDatesForPTD();
    const dataForPTDAmount: Record<string, any> = await getOrderAmount(datesForPTD?.data?.features[0]?.startDate, datesForPTD?.data?.features[0]?.endDate);
    const dataForPTDCount: Record<string, any> = await getorderCount(datesForPTD?.data?.features[0]?.startDate, datesForPTD?.data?.features[0]?.endDate);

    const datesForLastWeek: Record<string, any> = await getDatesForLastWeek();
    const dataForLastWeekAmount: Record<string, any> = await getOrderAmount(datesForLastWeek?.data?.features[0]?.startDate, datesForLastWeek?.data?.features[0]?.endDate);
    const dataForLastWeekCount: Record<string, any> = await getorderCount(datesForLastWeek?.data?.features[0]?.startDate, datesForLastWeek?.data?.features[0]?.endDate);

    const today = new Date();
    const todayStartDate = today.toISOString().split('T')[0] + ' 00:00:00.000';
    const todayEndDate = today.toISOString().split('T')[0] + ' 23:59:59.999';

    const dataForTodayAmount: Record<string, any> = await getOrderAmount(todayStartDate, todayEndDate);
    const dataForTodayCount: Record<string, any> = await getorderCount(todayStartDate, todayEndDate);

    const datesForLastMonth: Record<string, any> = await getDatesForLastMonth()
    const dataForLastMonthAmount: Record<string, any> = await getOrderAmount(datesForLastMonth?.data?.features[0]?.startDate, datesForLastMonth?.data?.features[0]?.endDate);
    const dataForLastMonthCount: Record<string, any> = await getorderCount(datesForLastMonth?.data?.features[0]?.startDate, datesForLastMonth?.data?.features[0]?.endDate);

    let result: Record<string, any>;
    result = {
        orderToday: dataForTodayAmount?.data?.features[0]?.value,
        orderLastWeek: dataForLastWeekAmount?.data?.features[0]?.value,
        orderCurrentMonth: dataForPTDAmount?.data?.features[0]?.value,
        orderLastMonth: dataForLastMonthAmount?.data?.features[0]?.value,
        orderValueToday: dataForTodayCount?.data?.features[0]?.value,
        orderValueLastWeek: dataForLastWeekCount?.data?.features[0]?.value,
        orderValueCurrentMonth: dataForPTDCount?.data?.features[0]?.value,
        orderValueLastMonth: dataForLastMonthCount?.data?.features[0]?.value
    }
    return result;
}


export async function getOrderAmount(fromDate: string, toDate: string) {
    let url = `/v3/analyticsreport/custom?queryName=orderAmount&fromDate=${fromDate}&toDate=${toDate}&source=portal&callType=scheduled`;
    try {
        const queryResponse = await getDataFromCache(url, 15, async () => {
            const response = await ChannelkartNetworkGet(url);
            if (response.status === 200) {
                return response;
            } else {
                return [];
            }
        });
        return queryResponse;
    } catch (err) {
        return [];
    }
}

export async function getorderCount(fromDate: string, toDate: string) {
    let url = `/v3/analyticsreport/custom?queryName=orderCount&fromDate=${fromDate}&toDate=${toDate}&source=portal&callType=scheduled`;
    try {
        const queryResponse = await getDataFromCache(url, 15, async () => {
            const response = await ChannelkartNetworkGet(url);
            if (response.status === 200) {
                return response;
            } else {
                return [];
            }
        });
        return queryResponse;
    } catch (err) {
        return [];
    }
}